export interface IPromiseResult<TResult, TErrors> {
    type: PromiseResultType;
    result?: TResult;
    errors?: TErrors;
}

export enum PromiseResultType {
    NotSpecified,
    Success,
    Error,
}
